import React, { useEffect, useState } from "react";
import orderService from "../../services/orderService";
import CrudTable from "../../components/dashboard/table/CrudTable";
import DashboardWrapper from "../../components/DashboardWrapper";

import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";

export default function AllOrders() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
const [searchText, setSearchText] = useState("");
const [startDate, setStartDate] = useState("");
const [endDate, setEndDate] = useState("");
  const columns = [
    "sl",
    "invoice_id",
    "user_name",
    "city",
    "order_status",
    "payment_status",
    "payment_method",
    "product_qty",
    "amount",
    "order_date",
  ];

  const fetchOrders = async () => {
    try {
      const response = await orderService.getAllOrders();
      const formattedOrders = response.data.orders.map((o, index) => ({
        sl: index + 1,

        ...o,
        user_name: o.user?.username || "N/A",
        city: o.order_address?.city || "N/A",
        product_qty: o.product_qty || 0,


        created_at: o.created_at,
        order_date: new Date(o.created_at).toLocaleString("en-GB", {
          weekday: "short", 
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true, 
        }),

      }));
      setOrders(formattedOrders);
    } catch (error) {
      console.error("Error fetching all orders:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handleEdit = (row) => navigate(`/admin/order/${row.id}`);
  const handleDelete = () => { };

  return (
    <DashboardWrapper>
      <div className="container-fluid mt-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <button
            className="btn btn-secondary d-flex align-items-center"
            onClick={() => navigate(-1)}
          >

            <span>Back</span>
          </button>
        </div>
        <div className="card shadow">
         
<div className="card-header">
  <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
    {/* Left side: Heading */}
    <h4 className="mb-0">All Orders</h4>

    {/* Right side: Date filters and search */}
    <div className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center gap-2">
      <input
        type="date"
        className="form-control"
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
        aria-label="Start date"
        style={{ minWidth: "150px" }}
      />

      <input
        type="date"
        className="form-control"
        value={endDate}
        min={startDate || undefined}
        onChange={(e) => setEndDate(e.target.value)}
        aria-label="End date"
        style={{ minWidth: "150px" }}
      />

      <input
        type="text"
        className="form-control"
        placeholder="Search orders..."
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        style={{ minWidth: "200px" }}
      />
    </div>
  </div>
</div>

          <div className="card-body">
            {loading ? (
              <Loader />
            ) : (
              <CrudTable
                data={orders}
                onEdit={handleEdit}
                onDelete={handleDelete}
                columns={columns}
                  searchText={searchText}
  startDate={startDate}
  endDate={endDate}
              />
            )}
          </div>
        </div>
      </div>
    </DashboardWrapper>
  );
}
